/*global fbq*/

import React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import 'airbnb-browser-shims'
import PropTypes from 'prop-types'
import auth from '../modules/auth'
import api from '../modules/api'
import config from '../modules/config'
import { subscribeNotificationChannel } from '../websocket'
import ReactGA from 'react-ga'
import { browserDetect } from '../modules/common'
import SessionExpiredModal from './SessionExpiredModal/SessionExpiredModal'

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired
  }

  constructor() {
    ReactGA.initialize(config.gaPropertyId, {
      debug: process.env.NODE_ENV === 'development'
    })

    if (config.facebookPixelId) {
      fbq('init', config.facebookPixelId)
      fbq('track', 'PageView')
    }

    super()
  }

  shouldComponentUpdate () {
    return false
  }

  componentDidMount() {
    const id = auth.getCustomerInfoBy('id')
    let self = this

    if (auth.loggedIn()) {
      api.fetchCustomerInfo(id)
        .then((response) => {
          auth.updateCustomerInfo(response.data.customer)
        })
        .catch(function (error) {
          auth.logout()
          self.props.history.push('/')
        })

      subscribeNotificationChannel()
    }
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <ConnectedRouter history={this.props.history}>
          <div className={browserDetect.detect} style={{ height: '100%' }}>
            {this.props.routes.map((route, i) => (
              route.routes.map((childRoute, j) => (
                <route.layout key={childRoute.path} {...childRoute}/>
              ))
            ))}
            <SessionExpiredModal />
          </div>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js